// extracted by css-extract-rspack-plugin
export default {"text":"CommunicationBannerView_text__24MTz","buttonText":"CommunicationBannerView_buttonText__xzK9N"};